import { render } from "./loading.vue?vue&type=template&id=4a36d832"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=4a36d832&lang=scss"

import exportComponent from "../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__